import { Statement } from '@/helpers/Interfaces';
import { axios } from '@/plugins/axios';

export default class LogitoAiService
{
    public static async passScanToAi(attachmentId: string): Promise<Statement>
    {
        return (await axios.post(`ai-assist/office?attachmentId=${attachmentId}`)).data;
    }

    public static async startAiProcessing(attachmentId: string): Promise<{ processId: string }>
    {
        const response = await axios.post(`ai-assist/office/async?attachmentId=${attachmentId}`);
        const processId = response.data?.result?.processId;

        if (!processId)
        {
            throw new Error('Invalid response structure from API - no processId found');
        }

        return { processId };
    }

    public static async getProcessingStatus(processId: string): Promise<any>
    {
        const response = await axios.get(`ai-assist/office/status/${processId}`);

        return response.data?.result;
    }

    public static async getIsAiEnabledForOffice(): Promise<boolean>
    {
        return (await axios.get('office/settings/ai/is-office-ai-enabled')).data;
    }

    /**
     * Generate regex pattern based on user prompt
     * @param prompt string - user description of what to validate
     * @returns Promise<string> - generated regex pattern
     */
    public static async generateRegex(prompt: string): Promise<string>
    {
        const response = await axios.post<string>('logito-ai/regex', {
            prompt: prompt
        });

        return response.data;
    }
}

